import { IStore } from 'store/configureStore';

export const selectIsAppSettingsUpdating = (state: IStore) =>
    state.modules.settings.clientsSettings.clients.appConfiguration.isUpdating;
